import React, { createRef } from "react";
import { CardOption, BookingPricingCard } from "../../components/";
import { api } from "../../api";
import Loading from "../Loading";
import moment from "moment-timezone";
import { toast, Bounce } from "react-toastify";
class Service extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedService: "",
      serviceOptions: [
        {
          name: "Car Wash",
          isSelected: true,
        },
        {
          name: "Wash & Detail",
          isSelected: false,
        },
      ],
      locationPricing: [],
      loading: true,
      toastMessage: createRef(null),
    };
    this.selectServiceType = this.selectServiceType.bind(this);
    this.displayServiceCapacityModal =
      this.displayServiceCapacityModal.bind(this);
  }

  selectServiceType(id, name, price, time, currentHour) {
    console.log("Service component selectServiceType called with:", {
      id,
      name,
      price,
      time,
      currentHour,
    });

    // If we only received an ID, find the full service object
    let serviceObject = null;
    if (id && (!name || !price || !time)) {
      // We need to find the full service object to get missing data
      serviceObject = this.state.locationPricing.find(
        (item) => item._id === id
      );
      if (serviceObject) {
        console.log("Found service object:", serviceObject);

        // Extract service name
        if (!name) {
          name = serviceObject.service?.[0]?.name || serviceObject.name;
        }

        // Extract pricing based on vehicle type
        if (!price) {
          const vehicleType = this.props.selectedVehicleType
            .split(" ")[0]
            .toLowerCase();
          const vehiclePricing = serviceObject[vehicleType];
          price = vehiclePricing?.price || vehiclePricing?.value;
        }

        // Extract duration
        if (!time) {
          time = serviceObject.duration;
        }
      }
    }

    const servicePrice = price;
    this.setState({
      selectedService: id,
    });

    this.setState((prevState) => ({
      serviceOptions: prevState.serviceOptions.map((obj) =>
        obj.name === name
          ? { ...obj, isSelected: true }
          : { ...obj, isSelected: false }
      ),
    }));

    console.log("Final values for handleSelectServiceType:", {
      name,
      id,
      servicePrice,
      currentHour,
    });
    this.props.handleSelectServiceType(name, id, servicePrice, currentHour);
  }

  async getLocationPricing(locationId) {
    console.log("Fetching location pricing for:", locationId);
    const pricing = await api(`location/${locationId}/pricing`, "GET", null);
    if (pricing.status == 200) {
      var resp = pricing.data;
      if (resp.success) {
        console.log("Location pricing response:", resp.pricing);
        console.log("First pricing item structure:", resp.pricing[0]);
        this.setState({
          locationPricing: resp.pricing,
          serviceOptions: resp.pricing,
        });
      } else {
        console.error("Failed to get location pricing:", resp.message);
        alert(resp.message);
      }
    } else {
      console.error("API call failed:", pricing);
    }
    this.setState({
      loading: false,
    });
  }

  componentDidMount() {
    if (typeof this.props.selectedServiceId == "object") {
      if (this.props.selectedServiceId.length > 0) {
        this.setState({
          selectedService: this.props.selectedServiceId[0].id,
        });
      }
    } else {
      if (this.props.selectedServiceId !== "") {
        this.setState({
          selectedService: this.props.selectedServiceId,
        });
      }
    }

    this.getLocationPricing(this.props.selectedLocation._id);
  }

  componentDidUpdate(prevProps) {
    // Sync with parent's selectedServiceId when it changes
    if (
      this.props.selectedServiceId !== prevProps.selectedServiceId &&
      this.props.selectedServiceId &&
      this.props.selectedServiceId.length > 0
    ) {
      const selectedServiceId = this.props.selectedServiceId[0].id;
      if (
        selectedServiceId &&
        selectedServiceId !== this.state.selectedService
      ) {
        console.log(
          "Syncing local selectedService state with parent:",
          selectedServiceId
        );
        this.setState({
          selectedService: selectedServiceId,
        });
      }
    }

    // Re-fetch pricing when location changes
    if (
      this.props.selectedLocation !== prevProps.selectedLocation &&
      this.props.selectedLocation
    ) {
      this.getLocationPricing(this.props.selectedLocation._id);
    }
  }

  displayServiceCapacityModal() {
    const error = toast.error(
      "Sorry, you are unable to select this service due to the booking time you have selected. Please select another time or service, Thank you.",
      {
        toastId: "serviceSelectErrorToast",
        position: "bottom-center",
        style: {
          bottom: "5vh",
        },
        autoClose: 7000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Bounce,
      }
    );
    this.state.toastMessage.current = error;
  }

  render() {
    console.log("Service component rendering with state:", this.state);
    console.log("Service component rendering with props:", this.props);

    let parentThis = this;
    const pricingOrder = [
      "Hand Polish",
      "Interior Detail",
      "Full Detail",
      "Paint Protection",
      "Ceramic Coating",
      "Express Wash",
      "Economy Wash",
      "Premium Wash",
      "Super Wash",
      "Mini Detail",
    ];
    const sortByObject = pricingOrder.reduce((obj, item, index) => {
      return {
        ...obj,
        [item]: index,
      };
    }, {});
    let pricingOptions = [];
    if (this.state.locationPricing) {
      pricingOptions = this.state.locationPricing.sort(
        (a, b) => sortByObject[a.name] - sortByObject[b.name]
      );
    }

    var allOptionsInactive = false;
    var countInactive = 0;
    var type = parentThis.props.selectedVehicleType;

    for (let po = 0; po < pricingOptions.length; po++) {
      const priceOption = pricingOptions[po];
      type = type.toLowerCase().split(" / ")[0].trim();
      if (priceOption[type]) {
        if (priceOption[type].active == false) {
          countInactive++;
        } else if (priceOption[type].value == 0) {
          countInactive++;
        }
      } else {
        countInactive++;
      }
    }

    if (countInactive === pricingOptions.length) {
      allOptionsInactive = true;
    }

    return (
      <div className="serviceStep">
        <h3>Select your service</h3>
        <div className="bookingPriceGrid">
          {this.state.loading ? (
            <div>
              <Loading />
            </div>
          ) : allOptionsInactive ? (
            <div>
              <p>
                Sorry, there are currently no services available for your
                selected vehicle type at{" "}
                {parentThis.props.selectedLocation.seoName}.
              </p>
              <p>
                Either select another location or contact us for more
                information.
              </p>
              <a
                className="contactLink"
                href={`${process.env.REACT_APP_MAIN_SITE_URL}/contact`}
                target={"_self"}
              >
                Contact Us
              </a>
            </div>
          ) : (
            pricingOptions.map(function (item, i) {
              console.log(`Pricing item ${i}:`, item);

              var selectedType = parentThis.props.selectedVehicleType;
              const activeOffer = parentThis.props.offerDetails; // passed as a prop
              let offerDiscount = null;

              if (activeOffer) {
                if (
                  !activeOffer.services ||
                  activeOffer.services.length === 0
                ) {
                  // No specific service restriction, apply offer to all
                  offerDiscount = {
                    value: activeOffer.value,
                    type: activeOffer.type,
                    code: activeOffer.code,
                  };
                } else {
                  const matchedService = activeOffer.services.find(
                    (service) => service._id === item._id
                  );
                  if (matchedService) {
                    offerDiscount = {
                      value: activeOffer.value,
                      type: activeOffer.type,
                      code: activeOffer.code,
                    };
                  }
                }
              }

              return (
                <BookingPricingCard
                  key={i}
                  item={item}
                  selectedType={selectedType}
                  dateRange={parentThis.props.dateRange}
                  selectServiceType={(id, name, price, time, currentHour) => {
                    var canSelect = false;
                    if (
                      parentThis.props.serviceSpecificCapacities !==
                        undefined &&
                      parentThis.props.serviceSpecificCapacities !== false
                    ) {
                      let serviceId = id;
                      if (
                        parentThis.props.serviceSpecificCapacities[serviceId]
                      ) {
                        canSelect = false;
                        var selectedTime = moment(
                          parentThis.props.dateRange.split(" - ")[0],
                          "MMM Do h:mmA"
                        ).format("HH:mm");
                        var availability =
                          parentThis.props.serviceSpecificCapacities[serviceId];
                        for (
                          let index = 0;
                          index < availability.length;
                          index++
                        ) {
                          const element = availability[index];
                          if (element.timeStart == selectedTime) {
                            canSelect = true;
                            break;
                          }
                        }
                      } else {
                        canSelect = true;
                      }
                    } else {
                      canSelect = true;
                    }

                    if (canSelect) {
                      console.log("selectedItem (id):", id);
                      console.log("currentHour:", currentHour);

                      toast.dismiss(parentThis.state.toastMessage.current);
                      // Get the vehicle-specific pricing
                      const vehicleType = selectedType
                        .split(" ")[0]
                        .toLowerCase();
                      // Find the item from locationPricing to get vehicle pricing
                      const serviceItem = item;
                      const vehiclePricing = serviceItem[vehicleType];

                      console.log("Vehicle type:", vehicleType);
                      console.log("Vehicle pricing:", vehiclePricing);
                      console.log("Selected item structure:", serviceItem);

                      parentThis.selectServiceType(
                        id,
                        name,
                        price,
                        time,
                        currentHour
                      );
                    } else {
                      parentThis.displayServiceCapacityModal();
                    }
                  }}
                  selectedService={parentThis.state.selectedService}
                  bundleSelected={parentThis.props.selectedBundle}
                  selectedLocation={parentThis.props.selectedLocation}
                  offerDiscount={offerDiscount} // ⬅ Pass discount info if matched
                />
              );
            })
          )}
        </div>
      </div>
    );
  }
}

export default Service;
